import PayoutsView from './PayoutsView';

export default PayoutsView;



// WEBPACK FOOTER //
// ./src/views/payoutsAndTaxes/payouts/index.js